import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, CircularProgress, Typography, Button, TextField, FormControlLabel,
  Checkbox, Dialog, DialogActions, DialogContent
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import AdminToolbar from "../Toolbar/AdminToolbar";
import "./EventDetails.css";
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';

const EventDetailsEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [formData, setFormData] = useState(null);
  const [enumOptions, setEnumOptions] = useState({ categories: [],
      postingTypes: [],
      costs: [], modes: [] });
  const [eventImage, setEventImage] = useState("");
  const [eventDocs, setEventDocs] = useState([]);
  const [pendingImageFile, setPendingImageFile] = useState(null);
  const [pendingDocs, setPendingDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [formError, setFormError] = useState("");
  const [edit, setEdit] = useState(false);
  const [savedPostCount,setsavedPostCount]= useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    async function load() {
      const [evtRes, optRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/adminevents/${id}`),
        axios.get(`${API_BASE_URL}/api/categoryValues`)
      ]);
      setEvent(evtRes.data);
      setFormData(evtRes.data);
      // setsavedPostCount(evtRes.data);
      setEventImage(evtRes.data.eventImage || "");
      setEventDocs(Array.isArray(evtRes.data.attachments) ? evtRes.data.attachments : []);
      setEnumOptions(optRes.data);
      setLoading(false);
    }
    load().catch(console.error);
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async () => {
    setFormError('');
    try {
      let imageUrl = formData.eventImage;
      let pdfUrls = formData.attachments || [];

      if (pendingImageFile) {
        const imgData = new FormData();
        imgData.append("image", pendingImageFile);
        imgData.append('eventName', formData.eventName);
        const res = await axios.post(`${API_BASE_URL}/upload-image`, imgData);
        imageUrl = res.data.imageUrl;
      }

      if (pendingDocs.length > 0) {
        pdfUrls = [];
        for (const file of pendingDocs) {
          const pdfData = new FormData();
          pdfData.append("file", file);
          pdfData.append('eventName', formData.eventName);
          const res = await axios.post(`${API_BASE_URL}/upload-pdf`, pdfData);
          if (res.data.pdfUrl) pdfUrls.push(res.data.pdfUrl);
        }
      }

      const payload = { ...formData, eventImage: imageUrl, attachments: pdfUrls };

      await axios.put(`${API_BASE_URL}/api/events/${id}`, payload);

      const refreshed = await axios.get(`${API_BASE_URL}/api/events/${id}`);
      setEvent(refreshed.data);
      setFormData(refreshed.data);
      setEventImage(refreshed.data.eventImage || "");
      setEventDocs(refreshed.data.attachments || []);
      setOpen(true);
    } catch (err) {
      console.error("Submission failed:", err);
      setFormError("Failed to save changes. Please try again.");
      setOpen(true);
    }
  };

  // const handleClose = () => setOpen(false);

  const handleClose = () => {
    setOpen(false);
    setFormError('');
    setEdit(false);
  };

  const handleEdit = () => {
    setEdit(true);
  };
  
  const HandleCancel = () => {
    setEdit(false);
  };
  if (loading) return <CircularProgress />;

  return (
    <>
      <AdminToolbar />
      <Box className="event-wrapper">
        <Box className="back-button-container">
          <Button variant="contained" onClick={() => navigate(-1)}>BACK</Button>
            {edit === false?<EditIcon onClick={handleEdit} /> : <CancelIcon onClick={HandleCancel} />}
        </Box>
        
        {edit === true?
        <Box className="event-main-layout">
          {/* <Box className="event-left">
            {eventImage && <img src={eventImage} alt="Event" className="event-thumbnail" />}
            {pendingImageFile ? (
              <img
                src={URL.createObjectURL(pendingImageFile)}
                alt="New Preview"
                className="event-thumbnail"
              />
            ) : (
              eventImage && <img src={eventImage} alt="Existing" className="event-thumbnail" />
            )}

            <Box mt={2}>
              <Button variant="outlined" component="label">
                Replace Image
                <input type="file" hidden onChange={(e) => setPendingImageFile(e.target.files[0])} />
              </Button>
            </Box>
          </Box> */}

          <Box className="event-center" sx={{ flex: 1, px: 2 }}>
            <TextField fullWidth name="eventName" label="Event Name" value={formData.eventName} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth type="date" name="postStartDate" label="Start Date" InputLabelProps={{ shrink: true }} value={formData.postStartDate?.slice(0,10)} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth type="date" name="postEndDate" label="End Date" InputLabelProps={{ shrink: true }} value={formData.postEndDate?.slice(0,10) || ""} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth type="date" name="applicationDeadline" label="App Deadline" InputLabelProps={{ shrink: true }} value={formData.applicationDeadline?.slice(0,10) || ""} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth multiline rows={4} name="description" label="Description" value={formData.description} onChange={handleChange} sx={{ mb: 2 }} />
            <Autocomplete multiple options={enumOptions.categories} value={formData.categories} onChange={(e, v) => setFormData(p => ({ ...p, categories: v }))} renderInput={params => <TextField {...params} label="Categories" />} sx={{ mb: 2 }} />
            {/* <Autocomplete multiple options={enumOptions.postingTypes} value={formData.postingTypes} onChange={(e, v) => setFormData(p => ({ ...p, postingTypes: v }))} renderInput={params => <TextField {...params} label="Posting Types" />} sx={{ mb: 2 }} /> */}
            <Autocomplete options={enumOptions.costs} value={formData.cost} onChange={(e, v) => setFormData(p => ({ ...p, cost: v }))} renderInput={params => <TextField {...params} label="Cost" />} sx={{ mb: 2 }} />
            <Autocomplete options={enumOptions.modes} value={formData.mode} onChange={(e, v) => setFormData(p => ({ ...p, mode: v }))} renderInput={params => <TextField {...params} label="Mode" />} sx={{ mb: 2 }} />
            <TextField fullWidth name="location" label="Location" value={formData.location} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth name="targetGroup" label="Target Group" value={formData.targetGroup} onChange={handleChange} sx={{ mb: 2 }} />
            <FormControlLabel control={<Checkbox name="yearlyImportant" checked={formData.yearlyImportant} onChange={handleChange} />} label="Recurring event" />
          </Box>

          <Box className="event-right" sx={{ minWidth: 240 }}>
            <TextField fullWidth name="hostOrganisation" label="Host Org" value={formData.hostOrganisation} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth name="hostURL" label="URL" value={formData.hostURL} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth name="onlineSessionLink" label="Online Meeting Link" value={formData.onlineSessionLink} onChange={handleChange} sx={{ mb: 2 }} />
            <TextField fullWidth disabled label="Posted By" value={formData.postedBy} sx={{ mb: 2 }} />

            <Box sx={{ mb: 2 }}>
            
                 <Typography variant="subtitle1" className="meta-label">Flyer</Typography>
                            {eventDocs.map((url, i) => (
                              <Box key={i} sx={{ my: 2 }}>
                                {/* Preview iframe */}
                                <iframe
                                  src={url}
                                  title={`Preview ${i}`}
                                  width="100%"
                                  height="150px"
                                  style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                                >
                                  
                                </iframe>
              
                                {/* Download/View link */}
                                <Box mt={1}>
                                  <a href={url} target="_blank" rel="noopener noreferrer">
                                  {event.eventName}
                                  </a>
                                </Box>
                              </Box>
                            ))}
                </Box>
                <Box mt={2}>
              <Button variant="outlined" component="label">
                Replace PDFs
                <input type="file" hidden multiple accept="application/pdf" onChange={e => setPendingDocs(Array.from(e.target.files))} />
              </Button>
            </Box> 

            <Button variant="contained" color="primary" onClick={handleSubmit}>Save Changes</Button>
          </Box>
        </Box>
        :
        <> <Box className="event-main-layout">
            <Box className="event-left">
              {/* {event.eventImage ? (
                <img src={event.eventImage}
                      alt={event.eventName}
                      className="event-thumbnail"
                    />
              ) : (
                <Box className="no-image"></Box>
              )} */}
            </Box>
        
            <Box className="event-center">
              <Typography variant="h4" className="event-title-text">{event.eventName}</Typography>
              <Typography className="event-date-text">
              Application Deadline : {event.applicationDeadline ? new Date(event.applicationDeadline).toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric"
                }) : "-"}
              </Typography>
              <Typography className="event-description" sx={{ mt: 2 }}>
                {event.description}
              </Typography>
            </Box>
        
            <Box className="event-right">
              <Typography className="meta-label">Host</Typography>
              <Typography className="meta-value">{event.hostOrganisation}</Typography>
        
              <Typography className="meta-label">Tag</Typography>
              <Typography className="meta-value">{event.categories?.join(", ")}</Typography>
        
        
              <Typography className="meta-label">Cost</Typography>
              <Typography className="meta-value">{event.cost}</Typography>
        
              {/* <Typography className="meta-label">Application Deadline</Typography>
              <Typography className="meta-value">
                {event.applicationDeadline ? new Date(event.applicationDeadline).toDateString() : "N/A"}
              </Typography> */}
         
                   <Typography variant="subtitle1" className="meta-label">Flyer</Typography>
                              {eventDocs.map((url, i) => (
                                <Box key={i} sx={{ my: 2 }}>
                                  {/* Preview iframe */}
                                  <iframe
                                    src={url}
                                    title={`Preview ${i}`}
                                    width="100%"
                                    height="150px"
                                    style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                                  >
                                    
                                  </iframe>
                
                                  {/* Download/View link */}
                                  <Box mt={1}>
                                    <a href={url} target="_blank" rel="noopener noreferrer">
                                     {event.eventName}
                                    </a>
                                  </Box>
                                </Box>
                              ))}
              <Typography className="meta-label">Posted By</Typography>
              <Typography className="meta-value">{event.postedBy}</Typography>
        
              <Typography className="meta-label">URL</Typography>
                <a href={event.hostURL} target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography className="meta-link">{event.hostURL}</Typography></a>     

                { (event.mode === "Online"  || event.mode === "Hybrid")? <>
                  <Typography className="meta-label">Location</Typography>
                  <Typography className="meta-value">{event.mode}</Typography>
        
                  {/* <Typography className="meta-label">Online Meeting Link</Typography>
                  <Typography className="meta-link">{event.onlineSessionLink}</Typography> */}
                  <Typography className="meta-label">Online Meeting Link</Typography>
                  <a href={event.onlineSessionLink} target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography className="meta-link">{event.onlineSessionLink}</Typography></a>                 
        
              </>: <>
              <Typography className="meta-label">Location</Typography>
              <Typography className="meta-value"> {event.mode} - {event.location}</Typography>
              </>
              }
           {/* <Typography className="meta-label">Saved Post Count</Typography>
              <Typography className="meta-value">{savedPostCount}</Typography>
               <Typography className="meta-label">View Post Count</Typography>
              <Typography className="meta-value">{savedPostCount}</Typography> */}
            </Box>
          </Box>
          </>}
      </Box>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {formError ? (
              <Typography color="error" sx={{ mt: 1 }}>{formError}</Typography>
            ) : (
              <Typography sx={{ mt: 1 }}>Event submitted successfully!</Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EventDetailsEdit;